import axios from "axios";
import { z } from "zod";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { TransitionDetails } from "../Types";
import { transitionUrl } from "./urls";
const GetAdvisorTransitionDetailsResponse = TransitionDetails;
const GetAdvisorTransitionDetailsErrorResponse = z.object({
    message: z.string(),
});
export default async function getTransitionDetails(advisorTransitionId, config) {
    try {
        const { data } = await axios.get(transitionUrl(advisorTransitionId), {
            headers: {
                Authorization: `Bearer ${config.jwt}`,
                Advisor: config.advisorId,
                Version: "20250617",
            },
        });
        const decoded = GetAdvisorTransitionDetailsResponse.safeParse(data);
        if (decoded.success) {
            return decoded.data;
        }
        else {
            const errorMessage = "[getTransitionDetails] returned unexpected data.";
            errorLog(getTransitionDetails.name, JSON.stringify(decoded.error.issues));
            throw new ValidationError(errorMessage, decoded.error.issues);
        }
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) {
            const errorData = error.response.data;
            const decodedError = GetAdvisorTransitionDetailsErrorResponse.safeParse(errorData);
            if (decodedError.success) {
                throw new Error(decodedError.data.message);
            }
        }
        throw error;
    }
}
//# sourceMappingURL=getTransitionDetails.js.map